// extracted by mini-css-extract-plugin
module.exports = {"featured":"project-module--featured--gOLGj","status":"project-module--status--298xF","ministatus":"project-module--ministatus--gffNN"};